import React from "react";
import { PhoneField } from "@qjumpers/common-ui";
import environmentConfig from "../../constants/config";

export const PhoneWrapper = (props) => (
  <>
    <PhoneField environmentConfig={environmentConfig} includesHostName={"public_api_1"} {...props} />
  </>
);
